import { render, staticRenderFns } from "./KoebTshirtPopup.vue?vue&type=template&id=f6b2f52a&scoped=true&"
import script from "./KoebTshirtPopup.vue?vue&type=script&lang=js&"
export * from "./KoebTshirtPopup.vue?vue&type=script&lang=js&"
import style0 from "./KoebTshirtPopup.vue?vue&type=style&index=0&id=f6b2f52a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f6b2f52a",
  null
  
)

export default component.exports